import Tab from "@Components/Tabs/Tab";
import Tabs from "@Components/Tabs/Tabs";
import TabsList from "@Components/Tabs/TabsList";
import appendWithString from "@Pages/Search/utils/appendWithString";
import Panel from "./components/Panel";
import wrapperHOC from "@Utils/wrapperHOC";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import useTranslationHook from "hooks/useTranslationHook";
import isAvailable from "@Utils/isAvailable";

type NearbySectionType = {
  isDesktop?: boolean;
};

const NearbySection = ({ isDesktop = false }: NearbySectionType) => {
  const {
    cities = [],
    areas = [],
    universities = [],
    inventories = [],
    searchListItems = [],
  } = useSelector(
    ({ searchPageData }: AppState) => ({
      cities: searchPageData?.nearbyData?.cities || [],
      areas: searchPageData?.nearbyData?.areas || [],
      universities: searchPageData?.nearbyData?.universities || [],
      inventories: searchPageData?.nearbyData?.inventories || [],
      searchListItems: searchPageData?.searchList?.items || [],
    }),
    shallowEqual,
  );

  const { t } = useTranslationHook();
  const top10CanonicalNames = new Set(
    searchListItems.slice(0, 10).map((item: any) => item.canonical_name),
  );

  const isActive = (item: any) => item?.status === "active";

  const activeAvailableProperties = inventories
    .filter((item) => isActive(item) && isAvailable(item))
    .filter((item: any) => !top10CanonicalNames.has(item.canonical_name));

  const SHOW_CITIES_TAB = cities && cities.length > 0;
  const SHOW_AREAS_TAB = areas && areas.length > 0;
  const SHOW_UNIVERSITIES_TAB = universities && universities.length > 0;
  const SHOW_INVENTORIES_TAB = activeAvailableProperties.length > 0;
  let defaultValue;
  if (SHOW_CITIES_TAB) {
    defaultValue = t("searchpage.components.nearbysection.citiespanel");
  } else if (SHOW_AREAS_TAB) {
    defaultValue = t("searchpage.components.nearbysection.areaspanel");
  } else if (SHOW_UNIVERSITIES_TAB) {
    defaultValue = t("searchpage.components.nearbysection.universitiespanel");
  } else if (SHOW_INVENTORIES_TAB) {
    defaultValue = t("searchpage.components.nearbysection.propertiespanel");
  }
  const showNearbyLinks = Boolean(
    SHOW_CITIES_TAB || SHOW_AREAS_TAB || SHOW_UNIVERSITIES_TAB || SHOW_INVENTORIES_TAB,
  );

  // useEffect(() => {
  //   const fetchRegion = async () => {
  //     if (region_fetch && region?.id) {
  //       try {
  //         const { data } = await getRegion(region.id, { methods: "root_name" });
  //         console.log(data);
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //   };
  //   fetchRegion();
  // }, [region_fetch, region?.id]);

  if (!showNearbyLinks) {
    return <></>;
  }

  return (
    <Tabs defaultValue={defaultValue} renderAllPanels>
      <TabsList removeMargin>
        {SHOW_CITIES_TAB && (
          <Tab
            value={t("searchpage.components.nearbysection.citiespanel")}
            dataTestId="nearbyCities-tabs"
          >
            {appendWithString(
              t("searchpage.components.nearbysection.citiestab"),
              t("searchpage.components.nearbysection.nearbyprefix"),
              false,
            )}
          </Tab>
        )}
        {SHOW_AREAS_TAB && (
          <Tab
            value={t("searchpage.components.nearbysection.areaspanel")}
            dataTestId="nearbyAreas-tabs"
          >
            {appendWithString(
              t("searchpage.components.nearbysection.localitiestab"),
              t("searchpage.components.nearbysection.nearbyprefix"),
              false,
            )}
          </Tab>
        )}
        {SHOW_UNIVERSITIES_TAB && (
          <Tab
            value={t("searchpage.components.nearbysection.universitiespanel")}
            dataTestId="nearbyUniversities-tabs"
          >
            {appendWithString(
              t("searchpage.components.nearbysection.universitiestab"),
              t("searchpage.components.nearbysection.nearbyprefix"),
              false,
            )}
          </Tab>
        )}
        {SHOW_INVENTORIES_TAB && (
          <Tab
            value={t("searchpage.components.nearbysection.propertiespanel")}
            dataTestId="nearbyInventories-tabs"
          >
            {appendWithString(
              t("searchpage.components.nearbysection.propertiestab"),
              t("searchpage.components.nearbysection.nearbyprefix"),
              false,
            )}
          </Tab>
        )}
      </TabsList>

      {SHOW_CITIES_TAB && (
        <Panel
          name={t("searchpage.components.nearbysection.citiespanel")}
          data={cities}
          isDesktop={isDesktop}
          dataTestId="cities"
        />
      )}
      {SHOW_AREAS_TAB && (
        <Panel
          name={t("searchpage.components.nearbysection.areaspanel")}
          data={areas}
          isDesktop={isDesktop}
          dataTestId="areas"
        />
      )}
      {SHOW_UNIVERSITIES_TAB && (
        <Panel
          name={t("searchpage.components.nearbysection.universitiespanel")}
          data={universities}
          isDesktop={isDesktop}
          dataTestId="universities"
        />
      )}
      {SHOW_INVENTORIES_TAB && (
        <Panel
          name={t("searchpage.components.nearbysection.propertiespanel")}
          data={activeAvailableProperties}
          isDesktop={isDesktop}
          dataTestId="properties"
        />
      )}
    </Tabs>
  );
};

export default wrapperHOC(NearbySection, {
  componentName: "NearbySection-SearchPage",
  showForChina: true,
  showForMiniProgram: false,
  showForApp: false,
});
